import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTable } from 'react-table';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      color: #91b9cd;
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`;
// const IndeterminateCheckbox1 = React.forwardRef(
//     ({ indeterminate, ...rest }, ref) => {
//         const defaultRef = React.useRef();
//         const resolvedRef = ref || defaultRef;

//         React.useEffect(() => {
//             resolvedRef.current.indeterminate = indeterminate;
//         }, [resolvedRef, indeterminate]);

//         return (
//             <>
//                 <input type="checkbox" ref={resolvedRef} {...rest} />
//             </>
//         );
//     }
// );

// Create a default prop getter
const defaultPropGetter = () => ({});
function Table({
  columns,
  data,
  idx,
  // getChildValue,
  getRowProps = defaultPropGetter,
}) {
  // Use the state and functions returned from useTable to build your UI
  const idxs = {};
  idxs[idx] = true;
  const {
    getTableProps,
    getTableBodyProps,
    toggleAllRowsSelected,
    toggleRowSelected,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    // state: { selectedRowIds },
  } = useTable({
    columns,
    data,
    // initialState: { selectedRowIds: idxs },
  });

  // Render the UI for your table
  return (
    <>
      <table {...getTableProps()}>
        <thead>
          <tr {...headerGroups[1].getHeaderGroupProps()}>
            {headerGroups[1].headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
          </tr>
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.slice(0, 10).map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

function MainList({ data, idx, getRowValue }) {
  const columns = useMemo(
    () => [
      {
        Header: 'Info',
        columns: [
          {
            Header: '序号',
            accessor: 'index',
          },
          {
            Header: 'Ai名称',
            accessor: 'name',
          },
          {
            Header: 'AI分析结果',
            accessor: 'resultInfo',
          },
          {
            Header: '处理结果',
            accessor: 'statusLabel',
          },
        ],
      },
    ],
    []
  );

  const childValue = data => {
    getRowValue(data);
  };

  return (
    <Styles>
      <Table
        columns={columns}
        data={data}
        idx={idx}
        getChildValue={childValue}
        getRowProps={row => ({
          style: {
            color: row.index === idx ? '#ffffff' : '',
          },
          onClick: () => getRowValue(row),
        })}
      />
    </Styles>
  );
}

export default MainList;
